import { useEffect, useState } from "react";
import { primary, secondary } from "models/CurrencyBond/data";
import { getSymbolById } from "helpers";
import { Container } from "./style";

export const Calculator = ({ currencies }) => {
  const [inputValue, setInputValue] = useState(1);
  const [selectOneValue, setSelectOneValue] = useState("PESO");
  const [selectTwoValue, setSelectTwoValue] = useState("DBNA");
  const [valueLeft, setValueLeft] = useState(1);
  const [valueRight, setValueRight] = useState(1);
  const [symbolLeftOne, setSymbolLeftOne] = useState(getSymbolById("PESO"));
  const [valueRightOne, setValueRightOne] = useState(1);
  const [symbolLeftTwo, setSymbolLeftTwo] = useState(getSymbolById("DBNA"));
  const [valueRightTwo, setValueRightTwo] = useState(1);
  const options = primary.concat(secondary);

  const onInputChange = ({ target }, setState) => {
    setState(target.value);    
  };

  const getDataCurrencySelect = (selectValue) => {
    return currencies.find((element) => element.id === selectValue);
  };

  const mathematicalOperation = (count, value1, value2) => {
    return (
      Math.round(
        ((parseFloat(count) * parseFloat(value1)) / parseFloat(value2)) * 100
      ) / 100
    );
  };

  const calculate = () => {
    const selectCurrencyOne = getDataCurrencySelect(selectOneValue);
    const selectCurrencyTwo = getDataCurrencySelect(selectTwoValue);
    
    if (!selectCurrencyOne || !selectCurrencyTwo) return;

    setValueLeft(`${inputValue} ${selectCurrencyOne.symbol}`);
    
    const result = mathematicalOperation(
      inputValue,
      selectCurrencyOne.sellingRate.replace(".","").replace(",", "."),
      selectCurrencyTwo.sellingRate.replace(".","").replace(",", ".")
    );

    if(result){
      setValueRight(`${result} ${selectCurrencyTwo.symbol}`);
    }else{
      setValueRight(`0 ${selectCurrencyTwo.symbol}`);
    }

    setSymbolLeftOne(selectCurrencyOne.symbol);
    
    const resultPerUnit = mathematicalOperation(
      1,
      selectCurrencyOne.buyingRate.replace(".","").replace(",", "."),
      selectCurrencyTwo.sellingRate.replace(".","").replace(",", ".")
    );
    setValueRightOne(`${resultPerUnit} ${selectCurrencyTwo.symbol}`);

    setSymbolLeftTwo(selectCurrencyTwo.symbol);
    
    const resultPerUnitReverse = mathematicalOperation(
      1,
      selectCurrencyTwo.sellingRate.replace(".","").replace(",", "."),
      selectCurrencyOne.buyingRate.replace(".","").replace(",", ".")
    );
    setValueRightTwo(`${resultPerUnitReverse} ${selectCurrencyOne.symbol}`);
  };

  useEffect(() => {
    calculate();
  }, [inputValue, selectOneValue, selectTwoValue, currencies]);

  return (
    <Container>
      <div className="card-converter">
        <h2 className="title-converter">Calculadora de moneda</h2>
        <input
          type="number"
          name="value"
          value={inputValue}
          onChange={(e) => onInputChange(e, setInputValue)}
        />

        <div className="options">
          <div className="op-1">
            <select
              onChange={(e) => onInputChange(e, setSelectOneValue)}
              defaultValue={selectOneValue}
            >
              {options.map((option, index) => (
                <option key={index + option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
          <div className="op-2">
            <select
              onChange={(e) => onInputChange(e, setSelectTwoValue)}
              defaultValue={selectTwoValue}
            >
              {options.map((option, index) => (
                <option key={index + option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="calculation-cointainer">
          <p className="result">
            {valueLeft} = {valueRight}
          </p>
          <p className="parameters">
            1 {symbolLeftOne} = {valueRightOne}
          </p>
          <p className="parameters">
            1 {symbolLeftTwo} = {valueRightTwo}
          </p>
        </div>
      </div>
    </Container>
  );
};
